function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.1523 1.4894C11.5291 0.836865 12.4709 0.836866 12.8477 1.4894L23.8674 20.5761C24.2441 21.2287 23.7732 22.0443 23.0197 22.0443H0.980266C0.22678 22.0443 -0.244147 21.2287 0.132596 20.5761L11.1523 1.4894Z",
  fill: "#627080"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.9334 15.2201L13.2467 8.1727H10.8505L11.1794 15.2201H12.9334ZM12.0564 18.7751C12.7455 18.7751 13.325 18.1957 13.325 17.5223C13.325 16.8332 12.7455 16.2537 12.0564 16.2537C11.3674 16.2537 10.8036 16.8332 10.8036 17.5223C10.8036 18.1957 11.3674 18.7751 12.0564 18.7751Z",
  fill: "white"
});

const SvgWarning = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWarning, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Warning.2e57fc86.svg";
export { ForwardRef as ReactComponent };